/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import BootstrapTable from 'react-bootstrap-table-next';

import TableSearch from '../TableSearch/TableSearch';
import Smilef from '../Smilef/Smilef';

import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import { useEffect } from 'react';
import { useState } from 'react';

const SIZEPERPAGE = 10;
const PAGINATIONSIZE = 6;

const pageListRenderer = ({ pages, onPageChange }) => {
  console.log('pages', pages);
  console.log('onPageChange', onPageChange);

  const pageWithoutIndication = pages.filter((p) => typeof p.page !== 'string');

  return (
    <div id="paginator-btns">
      {pageWithoutIndication.map((p) => (
        <button
          type="button"
          className={`btn btn-page ${p.active ? 'btn-active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            onPageChange(p.page);
          }}
        >
          {p.page}
        </button>
      ))}
    </div>
  );
};

function Table({ identificator, data, fields, isEmpty }) {
  const [options, setOptions] = useState({
    sizePerPage: SIZEPERPAGE,
    paginationSize: PAGINATIONSIZE,
    pageStartIndex: 1,
    prePageText: <i class="fa-solid fa-caret-left btn-page-back" aria-hidden="true"></i>,
    nextPageText: <i class="fa-solid fa-caret-right btn-page-next" aria-hidden="true"></i>,
    showTotal: false,
    disablePageTitle: true,
    hideSizePerPage: true,
    totalSize: data.length,
    pageListRenderer: pageListRenderer,
  });

  useEffect(() => {
    setOptions({ ...options, pageListRenderer: pageListRenderer });
  }, [data]);

  if (isEmpty) {
    return (
      <div className={`tableContainer ${identificator}`}>
        <Smilef sad message1="No se encontraron datos relacionados con la busqueda" />
      </div>
    );
  }

  return (
    <div className={`tableContainer ${identificator}`}>
      <PaginationProvider pagination={paginationFactory(options)}>
        {({ paginationTableProps }) => (
          <ToolkitProvider
            keyField={identificator}
            ignoreSinglePage
            scrollTop={'Bottom'}
            data={data}
            columns={fields.map((el, id) => ({
              ...el,
              key: id,
            }))}
            search={{
              afterSearch: (newResult) => console.log('newResult', newResult),
            }}
          >
            {({ searchProps, baseProps }) => (
              <>
                <TableSearch {...searchProps} />
                <BootstrapTable {...baseProps} {...paginationTableProps} />
              </>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </div>
  );
}

export default Table;
